
import { withCompController } from '@wix/editor-elements-integrations';
import type {
  IWbuNumericInputProps,
  IWbuNumericInputMapperProps,
  IWbuNumericInputControllerProps,
  IWbuNumericInputStateValues,
} from '../../../components/WbuNumericInput/WbuNumericInput.props';

export default withCompController<
  IWbuNumericInputMapperProps,
  IWbuNumericInputControllerProps,
  IWbuNumericInputProps,
  IWbuNumericInputStateValues
>(({ mapperProps, controllerUtils, stateValues }) => {
  const { editorType } = stateValues
  return {
    ...mapperProps,
    editorType,
    updateComponentPropsInViewer: props => {
      controllerUtils.updateProps(props);
    }
  }
});
